import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthGuard from '../components/AuthGuard';
import { api } from '../lib/api';

export default function PropertyProgress() {
  const navigate = useNavigate();
  const [area, setArea] = useState('138平方米');
  const residents = '3人';
  const direction = '南';
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/property-certificate/detail').then(({ data }) => {
      if (data.room?.size) setArea(data.room.size + '平方米');
    }).catch(() => {}).finally(() => setLoading(false));
  }, [navigate]);

  if (loading) {
    return (
      <div className="max-w-md mx-auto min-h-screen flex items-center justify-center" style={{ backgroundColor: '#c22a1e' }}>
        <div className="w-8 h-8 border-3 border-white/30 border-t-white rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto min-h-screen pb-6 relative" style={{ backgroundColor: '#c22a1e' }}>
      <AuthGuard />

      <button
        onClick={() => navigate(-1)}
        className="absolute top-4 left-4 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-black/20 text-white"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
      </button>

      {/* Header background image */}
      <div className="relative">
        <img src="/images/jindu_beijing.png" alt="" className="w-full" />
      {/* House Info Section */}
      <div className="px-3 absolute top-[240px] left-0 right-0 z-10">
        <div className="rounded-2xl overflow-hidden"> 
          <div className="flex items-start px-4 pb-4 gap-4">
            {/* Floor plan */}
            <div className="w-[180px] flex-shrink-0 bg-white rounded-lg p-2 shadow-sm border border-gray-100">
              <img src="/images/jindu_tu.png" alt="户型图" className="w-full" />
            </div>

            {/* Info items */}
            <div className="flex-1 space-y-2 pt-1">
              <div className="flex items-center gap-3 relative">
                <img src={"/images/jindu_pingfa.png"} className="w-[200px]" />
                <div className="absolute top-0 left-0 right-0 bottom-0 flex items-center justify-start">
                  <div className="text-[#666] text-xs w-[60px] ml-[35px]">房屋面积</div>
                  <div className="text-[#333] text-[15px] font-bold">{area}</div>
                </div>
              </div>
              <div className="flex items-center gap-3 relative">
                <img src={"/images/jindu_renshu.png"} className="w-[200px]" />
                <div className="absolute top-0 left-0 right-0 bottom-0 flex items-center justify-start">
                  <div className="text-[#666] text-xs w-[60px] ml-[35px]">居住人口</div>
                  <div className="text-[#333] text-[15px] font-bold">{residents}</div>
                </div>
              </div>
              <div className="flex items-center gap-3 relative">
                <img src={"/images/jindu_nan.png"} className="w-[200px]" />
                <div className="absolute top-0 left-0 right-0 bottom-0 flex items-center justify-start">
                  <div className="text-[#666] text-xs w-[60px] ml-[35px]">房屋朝向</div>
                  <div className="text-[#333] text-[15px] font-bold">{direction}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> 
 
      </div>

    </div>
  );
}
